module.exports = __webpack_public_path__ + "img/r-156.04c6fa72.jpg";